import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';

import contactIcon from '../../../assets/images/SVG/contact.svg';
import emailIcon from '../../../assets/images/SVG/email.svg';
import faxIcon from '../../../assets/images/SVG/fax.svg';
import phoneIcon from '../../../assets/images/SVG/phone.svg';

const ContactAdminModal = ({ isOpen, onClose }) => {
    const contactInfo = [
        { icon: phoneIcon, label: 'PHONE', value: '03 5432 1234' },
        { icon: faxIcon, label: 'FAX', value: '03 5432 1234' },
        { icon: emailIcon, label: 'EMAIL', value: 'info@eduone.com' }
    ];

    return (
        <Dialog
            open={isOpen}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
            scroll="body"
            slotProps={{
                backdrop: {
                    sx: {
                        backgroundColor: 'rgba(15, 23, 42, 0.35)',
                        backdropFilter: 'blur(4px)',
                    }
                }
            }}
            sx={{
                '& .MuiPaper-root': {
                    borderRadius: '24px !important',
                    boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1) !important',
                    p: { xs: 2.5, sm: 3.5 },
                    position: 'relative',
                    mx: 2,
                    boxSizing: 'border-box',
                    backgroundImage: 'none !important',
                    fontFamily: "'Poppins', sans-serif"
                }
            }}
        >
            <IconButton
                onClick={onClose}
                aria-label="close"
                sx={{
                    position: 'absolute',
                    right: 24,
                    top: 24,
                    color: '#94a3b8',
                    transition: 'all 0.2s ease',
                    '&:hover': {
                        color: '#475569',
                        backgroundColor: 'transparent'
                    }
                }}
            >
                <CloseIcon sx={{ fontSize: 20 }} />
            </IconButton>

            <DialogContent sx={{ p: 0, display: 'flex', flexDirection: 'column', alignItems: 'center', textAlign: 'center' }}>
                <Box
                    component="img"
                    src={contactIcon}
                    alt="Contact Admin"
                    sx={{
                        width: 72,
                        height: 'auto',
                        mb: 2,
                        filter: 'drop-shadow(0 8px 16px rgba(192, 54, 0, 0.12))'
                    }}
                />

                <Typography
                    variant="h5"
                    component="h2"
                    sx={{
                        fontSize: { xs: '20px', sm: '24px' },
                        fontWeight: 700,
                        color: '#1e1e38',
                        mb: 1.5,
                        letterSpacing: '-0.01em',
                        fontFamily: "'Poppins', sans-serif"
                    }}
                >
                    Contact EduOne Support Center
                </Typography>

                <Typography
                    variant="body2"
                    sx={{
                        fontSize: '13.5px',
                        lineHeight: 1.5,
                        color: '#64748b',
                        maxWidth: 460,
                        mb: 3,
                        fontFamily: "'Poppins', sans-serif"
                    }}
                >
                    If you are having trouble accessing your account, please contact the EduOne Support Center. Our support team is here to assist you.
                </Typography>

                <Box
                    sx={{
                        backgroundColor: '#F5F7F9',
                        borderRadius: '16px',
                        p: { xs: 2, sm: 2.5 },
                        width: '100%',
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        gap: { xs: 2.5, sm: 2 },
                        mb: 3,
                        boxSizing: 'border-box'
                    }}
                >
                    {contactInfo.map((item) => (
                        <Box
                            key={item.label}
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 1.5,
                                flex: 1,
                                justifyContent: 'center'
                            }}
                        >
                            <Box
                                component="img"
                                src={item.icon}
                                alt={item.label}
                                sx={{
                                    width: 24,
                                    height: 24,
                                    objectFit: 'contain',
                                    flexShrink: 0
                                }}
                            />
                            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', textAlign: 'left' }}>
                                <Typography
                                    component="span"
                                    sx={{
                                        fontSize: '11px',
                                        fontWeight: 700,
                                        color: '#1e1e38',
                                        letterSpacing: '0.05em',
                                        lineHeight: 1.2,
                                        mb: 0.5,
                                        fontFamily: "'Poppins', sans-serif"
                                    }}
                                >
                                    {item.label}
                                </Typography>
                                <Typography
                                    component="span"
                                    sx={{
                                        fontSize: '13px',
                                        fontWeight: 600,
                                        color: '#ff502d',
                                        whiteSpace: 'nowrap',
                                        lineHeight: 1.2,
                                        fontFamily: "'Poppins', sans-serif"
                                    }}
                                >
                                    {item.value}
                                </Typography>
                            </Box>
                        </Box>
                    ))}
                </Box>

                <Button
                    onClick={onClose}
                    variant="contained"
                    sx={{
                        backgroundColor: '#ff502d',
                        color: '#ffffff',
                        borderRadius: '15.22px',
                        px: { xs: 4, sm: 7 },
                        py: 1.25,
                        fontSize: '15px',
                        fontWeight: 600,
                        textTransform: 'none',
                        boxShadow: '0 8px 20px -6px rgba(255, 80, 45, 0.4)',
                        fontFamily: "'Poppins', sans-serif",
                        '&:hover': {
                            backgroundColor: '#e04324',
                            boxShadow: '0 12px 24px -6px rgba(255, 80, 45, 0.5)',
                            transform: 'translateY(-2px)'
                        },
                        '&:active': {
                            transform: 'translateY(0)',
                            boxShadow: '0 4px 12px -6px rgba(255, 80, 45, 0.4)'
                        },
                        transition: 'all 0.25s cubic-bezier(0.4, 0, 0.2, 1)',
                        width: { xs: '100%', sm: '240px' }
                    }}
                >
                    Done
                </Button>
            </DialogContent>
        </Dialog>
    );
};

export default ContactAdminModal;
